module.exports = __webpack_public_path__ + "static/img/areainfo1.97df143.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/areainfo1.png
// module id = Ipjo
// module chunks = 0